<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
  <div class="flex items-center gap-3">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">edit</mat-icon>
    <div>
      <h2 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #1e5a3f;">
        Editar Transacción
      </h2>
      <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
        #{{ data.idTransferencia }}
      </span>
    </div>
  </div>
</div>

<!-- Body -->
<div style="padding: 24px;">
  <form [formGroup]="datosForm" (ngSubmit)="guardarBeneficiario()" *ngIf="datosForm">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

      <!-- Nombres -->
      <div>
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Nombres</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">person</mat-icon>
          <input matInput formControlName="nombre" type="text" placeholder="Nombres">
        </mat-form-field>
        <div *ngIf="datosForm.get('nombre')!.touched && datosForm.get('nombre')!.invalid"
          style="display: flex; align-items: center; gap: 6px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 6px 12px; margin-top: -8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('nombre')!.hasError('required')">Este campo es obligatorio</span>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('nombre')!.hasError('maxlength')">Máximo 40 caracteres</span>
        </div>
      </div>

      <!-- Apellidos -->
      <div>
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Apellidos</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">person_outline</mat-icon>
          <input matInput formControlName="apellido" type="text" placeholder="Apellidos">
        </mat-form-field>
        <div *ngIf="datosForm.get('apellido')!.touched && datosForm.get('apellido')!.invalid"
          style="display: flex; align-items: center; gap: 6px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 6px 12px; margin-top: -8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('apellido')!.hasError('required')">Este campo es obligatorio</span>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('apellido')!.hasError('maxlength')">Máximo 40 caracteres</span>
        </div>
      </div>

      <!-- Red: la del beneficiario, fija (el guardado no la cambia en una edición) -->
      <div>
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 14px; background: #f9fafb; border: 1px solid #d1d5db; border-radius: 12px;">
          <mat-icon style="color: #6b7280; flex-shrink: 0;">lan</mat-icon>
          <div style="flex: 1; min-width: 0;">
            <span style="display: block; font-size: 0.72rem; font-weight: 600; color: #6b7280;">Red</span>
            <span style="display: block; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ red }}</span>
          </div>
          <mat-icon title="La red del beneficiario no se cambia" style="color: #9ca3af; font-size: 18px; width: 18px; height: 18px; flex-shrink: 0;">lock</mat-icon>
        </div>
      </div>

      <!-- Wallet (de la red de arriba; ya no siempre TRX) -->
      <div>
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Wallet</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">account_balance_wallet</mat-icon>
          <input matInput formControlName="medioRecepcion" type="text" placeholder="Wallet">
        </mat-form-field>
        <div *ngIf="datosForm.get('medioRecepcion')!.touched && datosForm.get('medioRecepcion')!.invalid"
          style="display: flex; align-items: center; gap: 6px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 6px 12px; margin-top: -8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('medioRecepcion')!.hasError('required')">Este campo es obligatorio</span>
          <!-- El motivo de la validación por red: el mismo texto que el alta y que wallet-back -->
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;"
            *ngIf="datosForm.get('medioRecepcion')!.hasError('direccionInvalida')">{{ datosForm.get('medioRecepcion')!.getError('direccionInvalida') }}</span>
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-3 mt-6 pt-4" style="border-top: 1px solid #e5e7eb;">
      <button type="button" (click)="cancel()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'"
        onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">close</mat-icon>
        Cancelar
      </button>
      <button type="submit"
        [disabled]="datosForm.invalid"
        [style.opacity]="datosForm.invalid ? '0.5' : '1'"
        [style.cursor]="datosForm.invalid ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'"
        onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
        Guardar
      </button>
    </div>
  </form>
</div>
